import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Products from './Products';
import StockManagement from './StockManagement';
import POSCheckout from './POSCheckout';
import POSOrders from './POSOrders';
import POSInvoices from './POSInvoices';
import { PageHeader } from '../../../ui';
import { getSessionUser, hasCompanyFeature, isPlatformSuperAdmin } from '../../../utils/roleAccess';

const BASE_URL = process.env.REACT_APP_BASE_URL;

function POS() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('products');
  const [role, setRole] = useState('');
  const [company_id, setCompanyID] = useState('');
  const [location_id, setLocationID] = useState('');

  useEffect(() => {
    const sessionStr = sessionStorage.getItem('user-info');
    if (sessionStr) {
      const session = JSON.parse(sessionStr);
      setRole(session.user.role);
      setCompanyID(session.user.company_id);
      setLocationID(session.user.location_id);
      if (isPlatformSuperAdmin(session.user.role) || !hasCompanyFeature(getSessionUser(), 'pos')) {
        navigate('/dashboard', { replace: true });
      }
    } else {
      navigate('/login');
    }
  }, [navigate]);

  const tabs = [
    { id: 'products', label: 'Products' },
    { id: 'stock', label: 'Stock Management' },
    { id: 'checkout', label: 'POS Checkout' },
    { id: 'orders', label: 'Orders' },
    { id: 'invoices', label: 'POS Invoices' },
  ];

  return (
    <div className="m-5">
      <PageHeader
        title="Point of Sale"
        subtitle="Products, stock, checkout, orders, and invoices"
      />

      <div className="flex border-b border-gx-border mb-5 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={activeTab === tab.id ? 'gx-tab-active whitespace-nowrap' : 'gx-tab whitespace-nowrap'}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="mt-5">
        {activeTab === 'products' && (
          <Products company_id={company_id} location_id={location_id} role={role} />
        )}
        {activeTab === 'stock' && (
          <StockManagement company_id={company_id} location_id={location_id} role={role} />
        )}
        {activeTab === 'checkout' && (
          <POSCheckout company_id={company_id} location_id={location_id} role={role} />
        )}
        {activeTab === 'orders' && (
          <POSOrders company_id={company_id} location_id={location_id} role={role} />
        )}
        {activeTab === 'invoices' && (
          <POSInvoices company_id={company_id} location_id={location_id} role={role} />
        )}
      </div>
    </div>
  );
}

export default POS;

